import { render } from "./CancelRemovalModal.vue?vue&type=template&id=049d4e6b&scoped=true"
import script from "./CancelRemovalModal.vue?vue&type=script&lang=js"
export * from "./CancelRemovalModal.vue?vue&type=script&lang=js"

import "./CancelRemovalModal.vue?vue&type=style&index=0&id=049d4e6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049d4e6b"],['__file',"src/components/CancelRemovalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "049d4e6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('049d4e6b', __exports__)) {
    api.reload('049d4e6b', __exports__)
  }
  
  module.hot.accept("./CancelRemovalModal.vue?vue&type=template&id=049d4e6b&scoped=true", () => {
    api.rerender('049d4e6b', render)
  })

}


export default __exports__